import { render, staticRenderFns } from "./ChainCardShowPerf.vue?vue&type=template&id=d87bf3e6&scoped=true&"
import script from "./ChainCardShowPerf.vue?vue&type=script&lang=ts&"
export * from "./ChainCardShowPerf.vue?vue&type=script&lang=ts&"
import style0 from "./ChainCardShowPerf.vue?vue&type=style&index=0&id=d87bf3e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87bf3e6",
  null
  
)

export default component.exports